import { FETCH_CITIES_REQUEST, SET_CITIES_DATA } from './types'
import { AreaGroupedCities } from './models'

// 州情報一覧を取得
export const fetchCitiesRequest = (
  countryCode: string
): Readonly<{
  type: 'FETCH_CITIES_REQUEST'
  payload: {
    countryCode: string
  }
}> => {
  return {
    type: FETCH_CITIES_REQUEST,
    payload: {
      countryCode: countryCode,
    },
  }
}

// 州情報一覧をセット
export const setCitiesData = (
  result: AreaGroupedCities[]
): Readonly<{
  type: 'SET_CITIES_DATA'
  payload: {
    cities: {
      result: AreaGroupedCities[]
    }
  }
}> => {
  return {
    type: SET_CITIES_DATA,
    payload: {
      cities: { result },
    },
  }
}
